import React from 'react';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import { REFERENCE_LAYERS_MIN_ZOOM } from '../../styles/mapTheme';
import ReferenceLayerRow from './ReferenceLayerRow';

/**
 * Zonificación urbana (hoy: Provincia de Córdoba, IDECOR 406).
 */
const ZonificacionUrbanaLayer = ({ enabled, onToggle, disabled = false, mapZoom = null }) => (
  <ReferenceLayerRow
    icon={LayersOutlinedIcon}
    title="Zonificación urbana"
    sublabel="Normativa de uso y edificación"
    enabled={enabled}
    onToggle={onToggle}
    disabled={disabled}
    mapZoom={mapZoom}
    minZoomToView={REFERENCE_LAYERS_MIN_ZOOM.zonificacionUrbana}
    zoomHintSublabel="Acercá más el zoom"
  />
);

export default ZonificacionUrbanaLayer;
